/**
 * Manual Redaction Toolbar Component
 * Allows users to add manual redactions via keyword search or drawing
 */

import { useState } from 'react';
import { Search, Edit3 } from 'lucide-react';

export default function ManualRedactionToolbar({
  onKeywordSearch,
  onToggleDrawMode,
  drawMode,
  isSearching
}) {
  const [keyword, setKeyword] = useState('');

  const handleSearch = () => {
    if (!keyword.trim()) {
      alert('Please enter a keyword to search');
      return;
    }
    onKeywordSearch(keyword);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && keyword.trim()) {
      handleSearch();
    }
  };

  return (
    <div className="bg-white border-b border-gray-200 p-3">
      <div className="flex items-center gap-3 flex-wrap">
        {/* Keyword Search Section */}
        <div className="flex items-center gap-2 flex-1 min-w-[300px]">
          <Search className="w-4 h-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search keyword to redact..."
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyPress={handleKeyPress}
            className="flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
          />
          <button
            onClick={handleSearch}
            disabled={isSearching || !keyword.trim()}
            className="px-3 py-1.5 text-sm bg-emerald-600 text-white rounded-md hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition"
          >
            {isSearching ? 'Searching...' : 'Find All'}
          </button>
        </div>

        <div className="h-6 w-px bg-gray-300" />

        {/* Draw Mode Toggle */}
        <button
          onClick={() => onToggleDrawMode(!drawMode)}
          className={`flex items-center gap-2 px-3 py-1.5 text-sm rounded-md transition ${
            drawMode
              ? 'bg-blue-600 text-white hover:bg-blue-700'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          <Edit3 className="w-4 h-4" />
          Draw Mode: {drawMode ? 'ON' : 'OFF'}
        </button>
      </div>

      {drawMode && (
        <div className="mt-2 px-3 py-2 bg-blue-50 border border-blue-200 rounded-md">
          <p className="text-sm text-blue-800">
            <strong>Draw Mode Active:</strong> Click and drag on the PDF to draw a rectangle around content you want to redact.
          </p>
        </div>
      )}
    </div>
  );
}
